import { render, staticRenderFns } from "./DidHeader.vue?vue&type=template&id=e1d1d7f4&scoped=true&"
import script from "./DidHeader.vue?vue&type=script&lang=js&"
export * from "./DidHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1d1d7f4",
  null
  
)

export default component.exports